/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface HService {
  /** 서비스 ID */
  _id: string;
  /** 서비스 대상이 되는 유저 ID */
  userID: string;
  /** 서비스 대상의 이름 */
  name: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: string;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: string;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID: string;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: string;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: any[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: any[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun: boolean;
  /** 모바일에서 환자가 서비스 이용 중단 요청한 경우, 시스템 또는 어드민 수준에서 특정 환자를 서비스 중단 처리한 경우 체크 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: any[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: any[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface HServiceUserChatroomMemoDoctorTreatmentCategoryUserTagVideoContentCategory {
  /** 서비스 대상이 되는 유저 ID */
  userID?: User;
  /** 서비스 대상의 이름 */
  name?: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone?: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: string;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: User;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID?: string;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: ChatRoom;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: Memo[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: UserTag[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun?: boolean;
  /** 서비스 종료 구분 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason?: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: TreatmentCategory[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: VideoContentCategory[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface User {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: string;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface AuthorizationType {
  /** 권한타입 객체 오브젝트 아이디 */
  _id: string;
  /**
   * 샘플 데이터 구분
   * @default false
   */
  isSample?: boolean;
  /** 권한타입이 속한 병원 아이디 */
  hospitalID: string;
  /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
  name?: string;
  /** 환자 채팅 관리 권한 */
  canControlPatientChatting?: boolean;
  /** 환자 서비스 차단 권한 */
  canBanPatientToService?: boolean;
  /** 자동화 설정 권한 */
  canUpsertAutomation?: boolean;
  /** 자동화 삭제 권한 */
  canDeleteAutomation?: boolean;
  /** 자동화 대시보드 조회 권한 */
  canReadAutomationDashboard?: boolean;
  /** 콘텐츠 수정 권한 */
  canUpsertContent?: boolean;
  /** 콘텐츠 삭제 권한 */
  canDeleteContent?: boolean;
  /** 메뉴얼 폴더 및 태그 설정 권한 */
  canControlManualFolderAndTagStatus?: boolean;
  /** 메뉴얼 생성 권한 */
  canCreateManual?: boolean;
  /** 병원 정보 조회 권한 */
  canAccessHospitalInformation?: boolean;
  /** 서비스 정보 조회 권한 */
  canAccessHospitalService?: boolean;
  /** 계정 정보 조회 권한 */
  canAccessHospitalAccount?: boolean;
  /** 결제 관리 접근 권한 */
  canAccessPaymentManagement?: boolean;
  /** 결제 권한 */
  canCreatePayment?: boolean;
  /** 서비스 정보 수정 권한 */
  canModifyService?: boolean;
  /** 서비스 종료 권한 */
  canSuspendService?: boolean;
  /** 예약설정 수정 권한 */
  canManageReservation?: boolean;
  /** 예약설정 스케줄 수정 권한 */
  canManageSchedule?: boolean;
  /** 병원정보 수정 권한 */
  canUpdateHospital?: boolean;
  /** 환자 정보 다운로드 권한 */
  canDownloadPatientData?: boolean;
  /** 재진 마케팅 등록/수정 */
  canUpsertMarketingAutomation?: boolean;
  /** 재진 마케팅 삭제 */
  canDeleteMarketingAutomation?: boolean;
  /** 대시보드 조회 여부 */
  canReadMarketingAutomationDashboard?: boolean;
  /** 결제 정보 조회 여부 */
  canReadPaymentRecords?: boolean;
  /** 재진마케팅 전송 기록 엑셀 다운로드 권한 */
  canDownloadMarketingHistory?: boolean;
  /** 상담자동화 발송 기록 엑셀 다운로드 권한 */
  canDownloadConsultationHistory?: boolean;
  /** 메디팔 AI 사용현황 조회 권한 */
  canReadMedipalAIUsage?: boolean;
  /** 메디팔 AI 업무 조정 권한 */
  canAdjustMedipalAITask?: boolean;
  /** 메디팔 AI 예약 조회 권한 */
  canReadMedipalAIReservation?: boolean;
  /** 메디팔 AI 콜 조회 권한 */
  canReadMedipalAICall?: boolean;
  /** 메디팔 AI 콜 최고 권한 */
  canControlMedipalAICall?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ChatRoom {
  /** 채팅방에 참여중인 서비스 ID */
  hserviceID?: string;
  /** 채팅방에 참여중인(Push notification을 받아야 하는.) 유저의 ID 배열 */
  users?: any[];
  /** 채팅의 주 대상이 되는(환자 or 의사) 유저의 ID */
  userID?: string;
  /** 채팅방 ID(_ID와 동일하고 _ID 사용 권장) */
  id?: string;
  /** 채팅방 _ID */
  _id: string;
  /** 채팅방 제목 */
  title?: string;
  /** 서비스매니저가 읽지 않은 채팅의 수 */
  n_UnreadCount?: number;
  /** 대상 유저가 읽지 않은 채팅의 수 */
  c_UnreadCount?: number;
  /** 채팅의 대상이 되는 유저가 처음 진입했는가에 대한 질의를 위한 플래그 */
  c_isFirstEnter?: boolean;
  /** 서비스 매니저의 첫 메세지 전송 여부 플래그 */
  c_isFirstNurseChat?: boolean;
  /** 대상 유저의 첫 메세지 구분 플래그 */
  c_isFirstUserChat?: boolean;
  /** 매니저의 첫 메세지 전송 이후를 확인하기 위한 플래그 */
  c_isSendedFirstNurseChat?: boolean;
  /** 해당 채팅방의 귀속 병원 ID */
  hospitalID?: string;
  /** 병원 계정과의 채팅방임을 구분짓는 플래그 */
  isDoctor?: boolean;
  /** 첫 메세지 전송을 통한 SMS 전송 여부 구분 플래그 */
  hasFirstSMS?: boolean;
  /** 마지막으로 전달된 메세지 모델 ID */
  lastMessage?: string;
  /** 마지막 메세지 전달 일시 */
  lastMessageUpdatedAt?: string;
  /** 채팅방 내에서의 총 메세지 수 */
  totalChatCount?: number;
  /** 마지막으로 환자가 전달한 채팅의 ObjectId */
  lastUserChat?: string;
  /** 마지막으로 환자가 전달한 채팅의 일시 */
  lastUserChatDate?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 ObjectId */
  lastNurseChat?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 일시 */
  lastNurseChatDate?: string;
  /** 참여 유저별 뱃지 카운트 정보 */
  badgeCountInfo?: Record<string, any>;
  /** 사용자 ID 별 필요한 정보의 집합 */
  info: {
    /**
     * 사용자 ID
     * @example "60b12345b1234c56789abcd1"
     */
    userID: string;
    /**
     * 채팅을 읽지 않은 갯수
     * @example 0
     */
    count: number;
    /**
     * 개인별 출력되는 채팅방 제목
     * @example "단체방"
     */
    title: string;
  }[];
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 채팅방의 병원 응대 필요 (상담 요청) 여부 */
  isChatResponseRequired?: boolean;
  /** 병원 응대 필요 채팅 (상담 요청) 존재 여부 */
  hasUnreadChatResponseRequired?: boolean;
  /** 채팅방 삭제 여부 */
  isRemoved?: boolean;
  /** 채팅방 타입 정의 */
  roomType?: string;
  /** 카카오 상담톡을 위한 추가 정보 */
  ikakaoInfo?: Record<string, any>;
  /** 채팅방의 담당자 ID 배열 */
  counselors?: any[];
  /**
   * 상담 진행중 여부
   * @default false
   */
  isCounselInProgress?: boolean;
  /**
   * 번역 사용 여부
   * @default false
   */
  usingTranslation?: boolean;
  /** 언어 ObjectId */
  languageID?: string;
  /** 활성화 여부 */
  isActive?: boolean;
  /** 채팅방에 연결된 부모 서비스 ID. 연동된 내용이 없으면 hserviceID와 동일 */
  parentHServiceID: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface Memo {
  /**
   * 메모 ID
   * @example "64b771e9a2b662448c1fe82b"
   */
  _id: string;
  /** 대상 병원 ID */
  hospitalID?: string;
  /** 대상 서비스 ID */
  hserviceID: string;
  /** 대상 유저 ID */
  userID?: string;
  /** 작성자 ID */
  writerID: string;
  /** 메인 콘텐츠 */
  mainContent?: string;
  /** 서브 콘텐츠 */
  subContent?: string;
  /** 콘텐츠 */
  content: string;
  /**
   * 병원측에서의 읽음 여부
   * @default true
   */
  d_Unread?: boolean;
  /**
   * 매니저 측에서의 읽음 여부
   * @default true
   */
  n_Unread?: boolean;
  /**
   * 병원으로부터 작성된 메모 여부
   * @default true
   */
  fromDoctor: boolean;
  /**
   * 초기치료내역에 대한 메모 여부
   * @default false
   */
  isInitialTreatment?: boolean;
  /** 메모 종류 - 2000 - 관리 방향 메모, 3001 - 서비스 매니저 메모 */
  type: number;
  /** 대상 병원 이름 */
  hospitalName: string;
  /** 작성자 이름 */
  writerName: string;
  /** 최종 수정자의 ID */
  modifierID?: string;
  /** 최종 수정자의 이름 */
  modifierName?: string;
  /** 메모 내 이미지 파일ID 목록 */
  fileIDs?: string[];
  /** 메모 삭제 여부 */
  isRemoved?: boolean;
  /** 메모 고정 여부 */
  isPinned: boolean;
  /** pin 업데이트 된 날짜 */
  pinUpdatedAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface UserTag {
  /** 태그의 고유 ID */
  _id?: string;
  /** 태그가 소속된 병원 ID */
  hospitalID?: string;
  /** 작성된 태그의 이름(병원 내 Unique) */
  name?: string;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface TreatmentCategory {
  /** 치료 태그 아이디 */
  _id: string;
  /** 고객유형(치료유형) 명칭 */
  categoryName: string;
  /** 병원ID */
  hospitalID: string;
  /**
   * 정렬순서
   * @default 9999
   */
  sortNum?: number;
  /** Colorpalette 모델의 basicPalette 인덱스 */
  paletteIndex?: number;
  /** 치료시 주의사항 treatmentCaution 아이디 */
  treatmentCautionID?: string;
  /**
   * 삭제 여부를 나타내는 플래그
   * @default false
   */
  isRemoved?: boolean;
  /** 커스텀 색상 사용 여부 - true일 경우 customColor 필드 필수 */
  isUsingCustomColor?: boolean;
  /**
   * 커스텀 색상 코드 - isUsingCustomColor가 true 가 아닌데 값이 들어있으면 오류 발생
   * @example "#FFFFFF"
   */
  customColor?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface VideoContentCategory {
  /** 홈케어 콘텐츠 카테고리 고유ID */
  _id?: string;
  /** 운동콘텐츠 카테고리명 */
  categoryName?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 정렬순서 */
  sortNum?: number;
  /** 상위 카테고리 ID. */
  parentCategoryIDs?: string[];
  /** 카테고리 대 여부 */
  isTop?: boolean;
  /** 카테고리 중 여부 */
  isParent?: boolean;
  /** 숨김 처리 여부 */
  isHidden?: boolean;
  /** 카테고리별 기초 콘텐츠 여부 */
  isBasic?: boolean;
  /** 운동콘텐츠 카테고리에 대한 설명 (oo의원 전용 콘텐츠 등) */
  description?: string;
  /** 카테고리의 명칭 (부위, 난이도, ...) */
  typeName?: string;
  /** 컨디셔닝 영상 여부 */
  isConditioning?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ElFindSimpleHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    name?: string;
    phone?: string;
    gender?: string;
    birth?: string;
    chartNumber?: string;
    /** @format date */
    lastLogin?: string;
    /** @format date */
    createdAt?: string;
    userID?: string;
    linkType?: string;
    userTagIDs?: any[];
    /** @format date */
    treatmentStartDate?: string;
    isFirstVisit?: boolean;
    isRun?: boolean;
    isClosed?: boolean;
    closeReason?: string;
    countryCode?: {
      /** MongoDB Identifier */
      _id: string;
      koreanCountryName?: string;
      internationalDialingCodes?: string;
    };
    nationality?: {
      /** MongoDB Identifier */
      _id: string;
      koreanCountryName?: string;
    } | null;
    /**
     * 광고성문자 수신동의
     * @example false
     */
    hasToBlockSendingMessage?: boolean | null;
    /** 그룹별 고객 태그 정보 */
    customTags?: Record<
      string,
      {
        tagId: string;
        name: string;
      }[]
    >;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ELAddCustomTagHandlerBodyRequest {
  /** HService ID */
  hserviceID: string;
  /** Custom Tag ID */
  customTagID: string;
}

export interface ELAddCustomTagHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** Success */
    success: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ELUpdateCustomTagByGroupHandlerBodyRequest {
  /** HService ID */
  hserviceID: string;
  /** Custom Tag Group ID */
  customTagGroupID: string;
  /** Custom Tag IDs */
  customTagIDs: string[];
}

export interface ELUpdateCustomTagByGroupHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** Success */
    success: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiHservicesElFindDetailParams {
  /** 서비스 ID */
  _id?: string;
}

export type ApiHservicesElFindDetailData = ApiResponse & {
  data: HService;
};

export interface ApiHservicesElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 */
  name?: string;
  /** 검색할 유저의 전화번호 */
  phone?: string;
  /** 검색할 유저의 생년월일 */
  birth?: string;
  /** 가입 여부 */
  isJoin?: boolean;
  /** 치료유형 ID 배열 */
  treatmentCategoryIDs?: string[];
  /** 태그 문자열 배열 */
  tag?: string;
  /** 담당의 ID */
  doctorID?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
  /** 등록일의 범위검색을 위한 시작 일시 */
  startedAt?: string;
  /** 등록일의 범위검색을 위한 종료 일시 */
  endedAt?: string;
  /** 연동사 종류 타입. 대소문자 구분 없음 */
  integrationType?: string;
  /** CRM 연동 여부 플래그 */
  isIntegrated?: string;
  /** 스킵할 수 */
  skip?: number;
  /** 가져오고자 하는 길이 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: number;
  /** 정렬하고자 하는 방향 */
  way?: number;
}

export type ApiHservicesElFindData = ApiResponse & {
  data: HServiceUserChatroomMemoDoctorTreatmentCategoryUserTagVideoContentCategory[];
};

export type ApiHservicesElSuspendData = ApiResponse & {
  data: HService;
};

export type ApiHservicesElUpdateSettingData = ApiResponse & {
  data: HService;
};

export type ApiHservicesElUpdateData = ApiResponse & {
  data: HService;
};

export interface ElFindSimpleHandlerParams {
  /** 병원 ID */
  hospitalID: string;
  /** 검색할 유저의 이름 혹은 전화번호 */
  keyword?: string;
  /** 검색할 유저의 이름, 전화번호 또는 차트번호 타입 */
  keywordType?: "name" | "phone" | "chartNumber";
  /** 정확한 매칭 여부 */
  exactMatch?: boolean | null;
  /** 마지막 로그인 정보 */
  lastLogin?: any;
  /** 테스트 계정 여부 (boolean 또는 MongoDB 쿼리 객체) */
  isTest?: any;
  /** 예약만 등록 계정 여부 (boolean 또는 MongoDB 쿼리 객체) */
  isUnregisteredUser?: any;
  /** 종료된 계정 여부 (boolean 또는 MongoDB 쿼리 객체) */
  isClosed?: any;
  /** 스킵할 수 */
  skip?: number | null;
  /** 가져오고자 하는 길이 */
  limit?: number | null;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number | null;
}

export type ElFindSimpleHandlerData = ElFindSimpleHandlerResponse;

export interface ApiHservicesHmFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 검색할 유저의 이름 혹은 전화번호 */
  keyword?: string;
  /** 테스트 계정 여부. 테스트 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isTest?: string;
  /** 예약만 등록 계정 여부. 예약만 등록 계정 미표기 시 {$ne\:true} 붙여서 조회 */
  isUnregisteredUser?: string;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHservicesHmFindSimpleData = {
  /** 서비스 ID */
  _id?: string;
  /** 서비스 대상의 이름 */
  name?: string;
  /** 서비스 대상의 전화번호 */
  phone?: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /**
   * 서비스 대상 유저의 마지막 로그인 일시
   * @format date
   */
  lastLogin?: string;
  /**
   * 생성일
   * @format date
   */
  createdAt?: string;
  /** 서비스 대상이 되는 유저 ID */
  userID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: string[];
  /**
   * 치료시작일
   * @format date
   */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 서비스 시작 여부 플래그 */
  isRun?: boolean;
  /** 서비스 종료 구분 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유 */
  closeReason?: string[];
  /** 국가 코드 정보 */
  countryCode?: {
    /** 국가 코드 ID */
    _id?: string;
    /** 한국어 국가명 */
    koreanCountryName?: string;
    /** 국제 전화번호 코드 */
    internationalDialingCodes?: string;
  };
  /** 국적 정보 */
  nationality?: {
    /** 국적 ID */
    _id?: string;
    /** 한국어 국가명 */
    koreanCountryName?: string;
  };
  /** 그룹별 고객 태그 정보 */
  customTags?: Record<
    string,
    {
      /** 고객 태그 ID */
      tagId?: string;
      /** 고객 태그 이름 */
      name?: string;
    }[]
  >;
}[];

export type ApiHservicesMSuspendData = any;

export type ApiHservicesMUpdateSelectData = any;

export type ElAddCustomTagHandlerData = ELAddCustomTagHandlerResponse;

export type ElUpdateCustomTagByGroupHandlerData = ELUpdateCustomTagByGroupHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesElFindDetail
     * @summary 서비스 상세 조회
     * @request GET:/v3/api/hservices/el/find/detail
     * @secure
     * @response `200` `ApiHservicesElFindDetailData` 서비스 상세 조회 성공
     */
    apiHservicesElFindDetail: (query: ApiHservicesElFindDetailParams, params: RequestParams = {}) =>
      this.request<ApiHservicesElFindDetailData, any>({
        path: `/v3/api/hservices/el/find/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesElFind
     * @summary 환자 조회
     * @request GET:/v3/api/hservices/el/find
     * @secure
     * @response `200` `ApiHservicesElFindData` 환자 조회 성공
     */
    apiHservicesElFind: (query: ApiHservicesElFindParams, params: RequestParams = {}) =>
      this.request<ApiHservicesElFindData, any>({
        path: `/v3/api/hservices/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesElSuspend
     * @summary 병원 앱에서의 유저 서비스 중단
     * @request POST:/v3/api/hservices/el/suspend
     * @secure
     * @response `200` `ApiHservicesElSuspendData` 서비스 중단 성공
     */
    apiHservicesElSuspend: (
      data: {
        /** 중단하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
        /** 중단하고자 하는 이유 */
        closeReason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHservicesElSuspendData, any>({
        path: `/v3/api/hservices/el/suspend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesElUpdateSetting
     * @summary 병원 앱에서의 유저 서비스 정보 수정
     * @request POST:/v3/api/hservices/el/update/setting
     * @secure
     * @response `200` `ApiHservicesElUpdateSettingData` 수정된 서비스 정보
     */
    apiHservicesElUpdateSetting: (
      data: {
        /** 업데이트 하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
        /** 해당 서비스의 담당의 ID */
        doctorID?: string;
        /** 치료유형의 카테고리 아이디 */
        treatmentCategoryIDs?: string;
        /** 관리방향 */
        memo?: string;
        memoFileIDs?: string[];
        /** 운동콘텐츠(기초) 발송 */
        videoContentCategoryIDs?: string;
        userTagIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHservicesElUpdateSettingData, any>({
        path: `/v3/api/hservices/el/update/setting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesElUpdate
     * @summary 병원 앱에서의 유저 서비스 정보 수정
     * @request POST:/v3/api/hservices/el/update
     * @secure
     * @response `200` `ApiHservicesElUpdateData` 수정된 서비스 정보
     */
    apiHservicesElUpdate: (
      data: {
        /** 수정하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHservicesElUpdateData, any>({
        path: `/v3/api/hservices/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description SaaS - 환자 간편 조회
     *
     * @tags V3-HService
     * @name ElFindSimpleHandler
     * @summary SaaS 환자 간편 조회: ts
     * @request GET:/v3/api/hservices/el/find/simple
     * @secure
     * @response `200` `ElFindSimpleHandlerData` success
     */
    elFindSimpleHandler: (query: ElFindSimpleHandlerParams, params: RequestParams = {}) =>
      this.request<ElFindSimpleHandlerData, any>({
        path: `/v3/api/hservices/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesHmFindSimple
     * @summary 환자 간편 조회 (애프터닥 관리자 앱)
     * @request GET:/v3/api/hservices/hm/find/simple
     * @secure
     * @response `200` `ApiHservicesHmFindSimpleData` 성공
     */
    apiHservicesHmFindSimple: (query: ApiHservicesHmFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiHservicesHmFindSimpleData, any>({
        path: `/v3/api/hservices/hm/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesMSuspend
     * @summary 유저에 의한 유저 서비스 중단
     * @request POST:/v3/api/hservices/m/suspend
     * @secure
     * @response `200` `ApiHservicesMSuspendData` \{User\} 수정된 유저 정보.
     */
    apiHservicesMSuspend: (
      data: {
        /** 중단하고자 하는 유저의 서비스 아이디 */
        hserviceID?: string;
        /** 중단하고자 하는 이유 */
        closeReason?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHservicesMSuspendData, any>({
        path: `/v3/api/hservices/m/suspend`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HService
     * @name ApiHservicesMUpdateSelect
     * @summary 다중 HService 생성 상태일 때 단일 서비스 선택
     * @request POST:/v3/api/hservices/m/update/select
     * @secure
     * @response `200` `ApiHservicesMUpdateSelectData` \{User\} 수정된 유저 정보.
     */
    apiHservicesMUpdateSelect: (
      data: {
        /** 사용자 ObjectId */
        userID?: string;
        /** 최종 사용할 병원 서비스 ObjectId */
        hserviceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHservicesMUpdateSelectData, any>({
        path: `/v3/api/hservices/m/update/select`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description SaaS - 커스텀태그 등록
     *
     * @tags V3-HService
     * @name ElAddCustomTagHandler
     * @summary SaaS - 커스텀태그 등록
     * @request POST:/v3/api/hservices/el/custom-tag
     * @secure
     * @response `200` `ElAddCustomTagHandlerData` success
     */
    elAddCustomTagHandler: (data: ELAddCustomTagHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ElAddCustomTagHandlerData, any>({
        path: `/v3/api/hservices/el/custom-tag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 고객 태그 유형에 속한 태그들만 업데이트
     *
     * @tags V3-HService
     * @name ElUpdateCustomTagByGroupHandler
     * @summary 특정 고객 태그 유형에 속한 태그들만 업데이트
     * @request PATCH:/v3/api/hservices/el/custom-tag
     * @secure
     * @response `200` `ElUpdateCustomTagByGroupHandlerData` success
     */
    elUpdateCustomTagByGroupHandler: (data: ELUpdateCustomTagByGroupHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ElUpdateCustomTagByGroupHandlerData, any>({
        path: `/v3/api/hservices/el/custom-tag`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
